import { ShieldCheck, Lock, Trash2 } from "lucide-react";

const POINTS = [
  {
    icon: ShieldCheck,
    title: "Never used to train AI models",
    body: "Resumes and evaluations are processed for your screening only — never fed into third-party model training.",
  },
  {
    icon: Lock,
    title: "Candidate data stays in your workspace",
    body: "Scores, reports and resume text are visible only to the members you invite. No cross-tenant access, ever.",
  },
  {
    icon: Trash2,
    title: "One-click erasure",
    body: "Delete a job, a batch or your whole account and the underlying candidate data goes with it, immediately.",
  },
];

export default function LandingTrustStrip() {
  return (
    <section className="px-4 py-14 sm:px-6 lg:px-8" data-testid="landing-trust-strip">
      <div className="glossy-card mx-auto max-w-6xl rounded-3xl border border-border/70 bg-card/70 px-6 py-10 sm:px-10">
        <div className="flex flex-col gap-2 text-center sm:text-left">
          <span className="text-xs font-bold uppercase tracking-widest text-primary">Privacy by design</span>
          <h2 className="font-heading text-xl font-bold tracking-tight sm:text-2xl">
            Built for GDPR-conscious hiring teams
          </h2>
        </div>
        <div className="mt-8 grid gap-6 sm:grid-cols-3">
          {POINTS.map(({ icon: Icon, title, body }, idx) => (
            <div
              key={title}
              style={{ animationDelay: `${idx * 80}ms` }}
              className="animate-in fade-in-0 slide-in-from-bottom-2 duration-500"
              data-testid={`trust-point-${idx}`}
            >
              <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/10">
                <Icon className="h-4 w-4 text-primary" />
              </div>
              <h3 className="mt-3 text-sm font-semibold">{title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
